// extracted by mini-css-extract-plugin
export default {"container":"e2aYRB6VqEnkrufR4px3","line":"Pgt_0jSPoAKsOwDjRBFy","img":"YCgZegRq_FPzWxXMiUU2","nameContainer":"WoOgdPoL2bjt1ySrZwMG","designerName":"kjuLOBK5JR9G2xRb8j7u"};